import type {Chart, Plugin, ChartType} from 'chart.js';

export type ReferenceLinesOptions = {
    x?: number;
    y?: number;
    color?: string;
    lineWidth?: number;
};

declare module 'chart.js' {
    interface PluginOptionsByType<TType extends ChartType> {
        referenceLines?: ReferenceLinesOptions;
    }
}

export const referenceLinesPlugin: Plugin<'scatter', ReferenceLinesOptions> = {
    id: 'referenceLines',

    defaults: {
        color: 'rgba(0, 0, 0, 0.35)',
        lineWidth: 1,
    },

    beforeDatasetDraw(chart: Chart, _args: unknown, options: ReferenceLinesOptions) {
        const {ctx, chartArea, scales} = chart;

        if (!scales.x || !scales.y) {
            return;
        }

        const {left, right, top, bottom} = chartArea;

        ctx.save();
        ctx.strokeStyle = options.color!;
        ctx.lineWidth = options.lineWidth!;
        ctx.setLineDash([]);

        if (!!options.x && Number.isFinite(options.x)) {
            const px = scales.x.getPixelForValue(options.x);
            if (px >= left && px <= right) {
                ctx.beginPath();
                ctx.moveTo(px, top);
                ctx.lineTo(px, bottom);
                ctx.stroke();
            }
        }

        if (!!options.y && Number.isFinite(options.y)) {
            const py = scales.y.getPixelForValue(options.y);
            if (py >= top && py <= bottom) {
                ctx.beginPath();
                ctx.moveTo(left, py);
                ctx.lineTo(right, py);
                ctx.stroke();
            }
        }

        ctx.setLineDash([]);
        ctx.restore();
    },
};
